import {Helpers} from "./helpers";

export class SiteHelpers {

	static readonly geopierSiteIdentifiers = ["www.geopier.com", "geopier.com", "author.geopier.com", "devstaging.geopier.com", "localhost:25292"];
	static readonly whSiteIdentifiers = ["www.tensarcorp.com","tensarcorp.com","author.tensarcorp.com", "devstaging.tensarcorp.com", "localhost:25291"];
	static readonly ehCulture = ["en-AU", "en-NZ"];//only used for wh site that has eh cultures. 


	public static isGeopier() : boolean {
		let currentUrl = window.location.hostname;
		return SiteHelpers.geopierSiteIdentifiers.includes(currentUrl);
	}
	public static isEasternHemisphere() : boolean {
		let currentUrl = window.location.hostname;
		return !SiteHelpers.geopierSiteIdentifiers.includes(currentUrl) &&
			!SiteHelpers.whSiteIdentifiers.includes(currentUrl);
	}

	public static isWesternHemisphere() : boolean {
		let currentUrl = window.location.hostname;
		return SiteHelpers.whSiteIdentifiers.includes(currentUrl);
	}
	
	public static isEhCulture() : boolean {
		const currentUrl = Helpers.getCurrentCulture();
		return SiteHelpers.ehCulture.includes(currentUrl);
	}
}